var map = {
	"./Exam/exam_check_red.svg": "./src/assets/images/Exam/exam_check_red.svg",
	"./Exam/exam_mark_correct.svg": "./src/assets/images/Exam/exam_mark_correct.svg",
	"./Exam/exam_mark_part.svg": "./src/assets/images/Exam/exam_mark_part.svg",
	"./Exam/exam_mark_wrong.svg": "./src/assets/images/Exam/exam_mark_wrong.svg",
	"./Q.svg": "./src/assets/images/Q.svg",
	"./alert_blue.svg": "./src/assets/images/alert_blue.svg",
	"./arrowBack.svg": "./src/assets/images/arrowBack.svg",
	"./arrowDown.svg": "./src/assets/images/arrowDown.svg",
	"./arrowDown_white.svg": "./src/assets/images/arrowDown_white.svg",
	"./arrowLeft_white.svg": "./src/assets/images/arrowLeft_white.svg",
	"./arrowLineDown_white.svg": "./src/assets/images/arrowLineDown_white.svg",
	"./arrowLineThickBottom.svg": "./src/assets/images/arrowLineThickBottom.svg",
	"./arrowLineThickDown.svg": "./src/assets/images/arrowLineThickDown.svg",
	"./arrowLineThickDown_blue.svg": "./src/assets/images/arrowLineThickDown_blue.svg",
	"./arrowLineThickLeft.svg": "./src/assets/images/arrowLineThickLeft.svg",
	"./arrowLineThickLeft_gray.svg": "./src/assets/images/arrowLineThickLeft_gray.svg",
	"./arrowLineThickLeft_white.svg": "./src/assets/images/arrowLineThickLeft_white.svg",
	"./arrowLineThickRight.svg": "./src/assets/images/arrowLineThickRight.svg",
	"./arrowLineThickRight_white.svg": "./src/assets/images/arrowLineThickRight_white.svg",
	"./arrowLineThickTop.svg": "./src/assets/images/arrowLineThickTop.svg",
	"./arrowLineThickTop_white.svg": "./src/assets/images/arrowLineThickTop_white.svg",
	"./arrowRightDown.svg": "./src/assets/images/arrowRightDown.svg",
	"./arrowRight_white.svg": "./src/assets/images/arrowRight_white.svg",
	"./arrowUp.svg": "./src/assets/images/arrowUp.svg",
	"./arrowUp_white.svg": "./src/assets/images/arrowUp_white.svg",
	"./arrow_comment.svg": "./src/assets/images/arrow_comment.svg",
	"./arrow_down_triangular_filled.svg": "./src/assets/images/arrow_down_triangular_filled.svg",
	"./arrow_triangle_down.svg": "./src/assets/images/arrow_triangle_down.svg",
	"./beta_blue.svg": "./src/assets/images/beta_blue.svg",
	"./cam_line_white.svg": "./src/assets/images/cam_line_white.svg",
	"./cam_off.svg": "./src/assets/images/cam_off.svg",
	"./cam_off_gray.svg": "./src/assets/images/cam_off_gray.svg",
	"./cam_off_red.svg": "./src/assets/images/cam_off_red.svg",
	"./cam_on.svg": "./src/assets/images/cam_on.svg",
	"./cam_on_white.svg": "./src/assets/images/cam_on_white.svg",
	"./camstudy/control_camera.svg": "./src/assets/images/camstudy/control_camera.svg",
	"./camstudy/control_camera_inactive.svg": "./src/assets/images/camstudy/control_camera_inactive.svg",
	"./camstudy/control_camera_notExist.svg": "./src/assets/images/camstudy/control_camera_notExist.svg",
	"./camstudy/control_chat.svg": "./src/assets/images/camstudy/control_chat.svg",
	"./camstudy/control_device_setting.svg": "./src/assets/images/camstudy/control_device_setting.svg",
	"./camstudy/control_more.svg": "./src/assets/images/camstudy/control_more.svg",
	"./camstudy/control_out.svg": "./src/assets/images/camstudy/control_out.svg",
	"./camstudy/control_participant.svg": "./src/assets/images/camstudy/control_participant.svg",
	"./camstudy/gooroomee_study_download_image1.png": "./src/assets/images/camstudy/gooroomee_study_download_image1.png",
	"./camstudy/gooroomee_study_download_image2.png": "./src/assets/images/camstudy/gooroomee_study_download_image2.png",
	"./camstudy/gooroomee_study_download_image3.png": "./src/assets/images/camstudy/gooroomee_study_download_image3.png",
	"./camstudy/ico_arrowLeft_white.svg": "./src/assets/images/camstudy/ico_arrowLeft_white.svg",
	"./camstudy/ico_arrowLineLeft.svg": "./src/assets/images/camstudy/ico_arrowLineLeft.svg",
	"./camstudy/ico_arrowLineLeft_white.svg": "./src/assets/images/camstudy/ico_arrowLineLeft_white.svg",
	"./camstudy/ico_arrowLineRight.svg": "./src/assets/images/camstudy/ico_arrowLineRight.svg",
	"./camstudy/ico_arrowLineRight_white.svg": "./src/assets/images/camstudy/ico_arrowLineRight_white.svg",
	"./camstudy/ico_arrowLineThickLeft.svg": "./src/assets/images/camstudy/ico_arrowLineThickLeft.svg",
	"./camstudy/ico_arrowLineThickLeft_white.svg": "./src/assets/images/camstudy/ico_arrowLineThickLeft_white.svg",
	"./camstudy/ico_arrowLineTop_white.svg": "./src/assets/images/camstudy/ico_arrowLineTop_white.svg",
	"./camstudy/ico_arrowRight_gray.svg": "./src/assets/images/camstudy/ico_arrowRight_gray.svg",
	"./camstudy/ico_arrowTriangleDown.svg": "./src/assets/images/camstudy/ico_arrowTriangleDown.svg",
	"./camstudy/ico_arrowTriangleRight_white.svg": "./src/assets/images/camstudy/ico_arrowTriangleRight_white.svg",
	"./camstudy/ico_attendance_minus.svg": "./src/assets/images/camstudy/ico_attendance_minus.svg",
	"./camstudy/ico_attendance_plus.svg": "./src/assets/images/camstudy/ico_attendance_plus.svg",
	"./camstudy/ico_attendance_white.svg": "./src/assets/images/camstudy/ico_attendance_white.svg",
	"./camstudy/ico_block_member_white.svg": "./src/assets/images/camstudy/ico_block_member_white.svg",
	"./camstudy/ico_block_white.svg": "./src/assets/images/camstudy/ico_block_white.svg",
	"./camstudy/ico_blur_video_white.svg": "./src/assets/images/camstudy/ico_blur_video_white.svg",
	"./camstudy/ico_camera_black.svg": "./src/assets/images/camstudy/ico_camera_black.svg",
	"./camstudy/ico_camera_transition.svg": "./src/assets/images/camstudy/ico_camera_transition.svg",
	"./camstudy/ico_camera_white.svg": "./src/assets/images/camstudy/ico_camera_white.svg",
	"./camstudy/ico_chat_send_impossible.svg": "./src/assets/images/camstudy/ico_chat_send_impossible.svg",
	"./camstudy/ico_chat_send_possible.svg": "./src/assets/images/camstudy/ico_chat_send_possible.svg",
	"./camstudy/ico_check.svg": "./src/assets/images/camstudy/ico_check.svg",
	"./camstudy/ico_check_blue.svg": "./src/assets/images/camstudy/ico_check_blue.svg",
	"./camstudy/ico_check_white.svg": "./src/assets/images/camstudy/ico_check_white.svg",
	"./camstudy/ico_close_gray.svg": "./src/assets/images/camstudy/ico_close_gray.svg",
	"./camstudy/ico_close_white.svg": "./src/assets/images/camstudy/ico_close_white.svg",
	"./camstudy/ico_determination_black.svg": "./src/assets/images/camstudy/ico_determination_black.svg",
	"./camstudy/ico_device_audiooutput.svg": "./src/assets/images/camstudy/ico_device_audiooutput.svg",
	"./camstudy/ico_device_video.svg": "./src/assets/images/camstudy/ico_device_video.svg",
	"./camstudy/ico_download_white.svg": "./src/assets/images/camstudy/ico_download_white.svg",
	"./camstudy/ico_help_white.svg": "./src/assets/images/camstudy/ico_help_white.svg",
	"./camstudy/ico_info_darkgray.svg": "./src/assets/images/camstudy/ico_info_darkgray.svg",
	"./camstudy/ico_modify_black.svg": "./src/assets/images/camstudy/ico_modify_black.svg",
	"./camstudy/ico_modify_white.svg": "./src/assets/images/camstudy/ico_modify_white.svg",
	"./camstudy/ico_more_gray.svg": "./src/assets/images/camstudy/ico_more_gray.svg",
	"./camstudy/ico_music_off_white.svg": "./src/assets/images/camstudy/ico_music_off_white.svg",
	"./camstudy/ico_music_white.svg": "./src/assets/images/camstudy/ico_music_white.svg",
	"./camstudy/ico_my_setting_white.svg": "./src/assets/images/camstudy/ico_my_setting_white.svg",
	"./camstudy/ico_no_cam.svg": "./src/assets/images/camstudy/ico_no_cam.svg",
	"./camstudy/ico_noise_white.svg": "./src/assets/images/camstudy/ico_noise_white.svg",
	"./camstudy/ico_option_radio_checked.svg": "./src/assets/images/camstudy/ico_option_radio_checked.svg",
	"./camstudy/ico_option_radio_not_checked.svg": "./src/assets/images/camstudy/ico_option_radio_not_checked.svg",
	"./camstudy/ico_partcipant_white.svg": "./src/assets/images/camstudy/ico_partcipant_white.svg",
	"./camstudy/ico_participant_invite_white.svg": "./src/assets/images/camstudy/ico_participant_invite_white.svg",
	"./camstudy/ico_participant_permission.svg": "./src/assets/images/camstudy/ico_participant_permission.svg",
	"./camstudy/ico_pause_white.svg": "./src/assets/images/camstudy/ico_pause_white.svg",
	"./camstudy/ico_pin_active.svg": "./src/assets/images/camstudy/ico_pin_active.svg",
	"./camstudy/ico_pin_inactive.svg": "./src/assets/images/camstudy/ico_pin_inactive.svg",
	"./camstudy/ico_pin_white.svg": "./src/assets/images/camstudy/ico_pin_white.svg",
	"./camstudy/ico_polygon_gray.svg": "./src/assets/images/camstudy/ico_polygon_gray.svg",
	"./camstudy/ico_radio_checked.svg": "./src/assets/images/camstudy/ico_radio_checked.svg",
	"./camstudy/ico_radio_not_checked.svg": "./src/assets/images/camstudy/ico_radio_not_checked.svg",
	"./camstudy/ico_reload.svg": "./src/assets/images/camstudy/ico_reload.svg",
	"./camstudy/ico_reload_blue.svg": "./src/assets/images/camstudy/ico_reload_blue.svg",
	"./camstudy/ico_reload_circle_white.svg": "./src/assets/images/camstudy/ico_reload_circle_white.svg",
	"./camstudy/ico_reload_white.svg": "./src/assets/images/camstudy/ico_reload_white.svg",
	"./camstudy/ico_resetSticker_white.svg": "./src/assets/images/camstudy/ico_resetSticker_white.svg",
	"./camstudy/ico_room_info_white.svg": "./src/assets/images/camstudy/ico_room_info_white.svg",
	"./camstudy/ico_room_url_copy_white.svg": "./src/assets/images/camstudy/ico_room_url_copy_white.svg",
	"./camstudy/ico_saveSticker_white.svg": "./src/assets/images/camstudy/ico_saveSticker_white.svg",
	"./camstudy/ico_save_study_white.svg": "./src/assets/images/camstudy/ico_save_study_white.svg",
	"./camstudy/ico_stopwatch_setting_white.svg": "./src/assets/images/camstudy/ico_stopwatch_setting_white.svg",
	"./camstudy/ico_study_setting_white.svg": "./src/assets/images/camstudy/ico_study_setting_white.svg",
	"./camstudy/ico_toast_content.svg": "./src/assets/images/camstudy/ico_toast_content.svg",
	"./camstudy/ico_toast_error.svg": "./src/assets/images/camstudy/ico_toast_error.svg",
	"./camstudy/ico_toast_info.svg": "./src/assets/images/camstudy/ico_toast_info.svg",
	"./camstudy/ico_toast_success.svg": "./src/assets/images/camstudy/ico_toast_success.svg",
	"./camstudy/ico_triangle_down_white.png": "./src/assets/images/camstudy/ico_triangle_down_white.png",
	"./camstudy/ico_upload_white.svg": "./src/assets/images/camstudy/ico_upload_white.svg",
	"./camstudy/ico_user.svg": "./src/assets/images/camstudy/ico_user.svg",
	"./camstudy/ico_white_noise.svg": "./src/assets/images/camstudy/ico_white_noise.svg",
	"./camstudy/ico_white_noise_white.svg": "./src/assets/images/camstudy/ico_white_noise_white.svg",
	"./camstudy/ico_widget_setting_white.svg": "./src/assets/images/camstudy/ico_widget_setting_white.svg",
	"./camstudy/ico_wonder.svg": "./src/assets/images/camstudy/ico_wonder.svg",
	"./camstudy/loading_gooroomee_change_type.png": "./src/assets/images/camstudy/loading_gooroomee_change_type.png",
	"./camstudy/logo_gooroomee.svg": "./src/assets/images/camstudy/logo_gooroomee.svg",
	"./camstudy/logo_gooroomee_blue_016FF2.svg": "./src/assets/images/camstudy/logo_gooroomee_blue_016FF2.svg",
	"./camstudy/mobile_premium_feature_001.jpg": "./src/assets/images/camstudy/mobile_premium_feature_001.jpg",
	"./camstudy/mobile_premium_feature_002.jpg": "./src/assets/images/camstudy/mobile_premium_feature_002.jpg",
	"./camstudy/mobile_premium_feature_003.jpg": "./src/assets/images/camstudy/mobile_premium_feature_003.jpg",
	"./camstudy/mobile_premium_feature_004.jpg": "./src/assets/images/camstudy/mobile_premium_feature_004.jpg",
	"./camstudy/mobile_premium_feature_005.jpg": "./src/assets/images/camstudy/mobile_premium_feature_005.jpg",
	"./camstudy/mobile_premium_feature_006.jpg": "./src/assets/images/camstudy/mobile_premium_feature_006.jpg",
	"./camstudy/not_devcie_alert_image.png": "./src/assets/images/camstudy/not_devcie_alert_image.png",
	"./camstudy/person.svg": "./src/assets/images/camstudy/person.svg",
	"./camstudy/premium_background.png": "./src/assets/images/camstudy/premium_background.png",
	"./camstudy/preview_gooroomee_name.svg": "./src/assets/images/camstudy/preview_gooroomee_name.svg",
	"./camstudy/stopwatch_background_image1.svg": "./src/assets/images/camstudy/stopwatch_background_image1.svg",
	"./camstudy/stopwatch_background_image2.svg": "./src/assets/images/camstudy/stopwatch_background_image2.svg",
	"./camstudy/stopwatch_background_image3.svg": "./src/assets/images/camstudy/stopwatch_background_image3.svg",
	"./camstudy/stopwatch_background_image4.svg": "./src/assets/images/camstudy/stopwatch_background_image4.svg",
	"./camstudy/stopwatch_background_image5.svg": "./src/assets/images/camstudy/stopwatch_background_image5.svg",
	"./camstudy/stopwatch_background_image6.svg": "./src/assets/images/camstudy/stopwatch_background_image6.svg",
	"./camstudy/stopwatch_basic_blue.svg": "./src/assets/images/camstudy/stopwatch_basic_blue.svg",
	"./camstudy/stopwatch_basic_dark.svg": "./src/assets/images/camstudy/stopwatch_basic_dark.svg",
	"./camstudy/stopwatch_blue.svg": "./src/assets/images/camstudy/stopwatch_blue.svg",
	"./camstudy/stopwatch_blueGreen.svg": "./src/assets/images/camstudy/stopwatch_blueGreen.svg",
	"./camstudy/stopwatch_green.svg": "./src/assets/images/camstudy/stopwatch_green.svg",
	"./camstudy/stopwatch_menu_basic.svg": "./src/assets/images/camstudy/stopwatch_menu_basic.svg",
	"./camstudy/stopwatch_menu_cash.svg": "./src/assets/images/camstudy/stopwatch_menu_cash.svg",
	"./camstudy/stopwatch_menu_pomodoro.svg": "./src/assets/images/camstudy/stopwatch_menu_pomodoro.svg",
	"./camstudy/stopwatch_pass_white.svg": "./src/assets/images/camstudy/stopwatch_pass_white.svg",
	"./camstudy/stopwatch_pause_click.svg": "./src/assets/images/camstudy/stopwatch_pause_click.svg",
	"./camstudy/stopwatch_pause_not_click.svg": "./src/assets/images/camstudy/stopwatch_pause_not_click.svg",
	"./camstudy/stopwatch_pause_rest.svg": "./src/assets/images/camstudy/stopwatch_pause_rest.svg",
	"./camstudy/stopwatch_pause_white.svg": "./src/assets/images/camstudy/stopwatch_pause_white.svg",
	"./camstudy/stopwatch_pink.svg": "./src/assets/images/camstudy/stopwatch_pink.svg",
	"./camstudy/stopwatch_pomodoro_bar.svg": "./src/assets/images/camstudy/stopwatch_pomodoro_bar.svg",
	"./camstudy/stopwatch_pomodoro_bar_01.svg": "./src/assets/images/camstudy/stopwatch_pomodoro_bar_01.svg",
	"./camstudy/stopwatch_pomodoro_circle.svg": "./src/assets/images/camstudy/stopwatch_pomodoro_circle.svg",
	"./camstudy/stopwatch_pomodoro_circle_01.svg": "./src/assets/images/camstudy/stopwatch_pomodoro_circle_01.svg",
	"./camstudy/stopwatch_pomodoro_mobile.svg": "./src/assets/images/camstudy/stopwatch_pomodoro_mobile.svg",
	"./camstudy/stopwatch_puple.svg": "./src/assets/images/camstudy/stopwatch_puple.svg",
	"./camstudy/stopwatch_reset_white.svg": "./src/assets/images/camstudy/stopwatch_reset_white.svg",
	"./camstudy/stopwatch_yellow.svg": "./src/assets/images/camstudy/stopwatch_yellow.svg",
	"./camstudy/test_feature_image.svg": "./src/assets/images/camstudy/test_feature_image.svg",
	"./camstudy/vacancy_detection_image.svg": "./src/assets/images/camstudy/vacancy_detection_image.svg",
	"./camstudy/video_view_block.svg": "./src/assets/images/camstudy/video_view_block.svg",
	"./camstudy/warning_declaration.svg": "./src/assets/images/camstudy/warning_declaration.svg",
	"./chat.svg": "./src/assets/images/chat.svg",
	"./chatbot.png": "./src/assets/images/chatbot.png",
	"./chatbot_white.png": "./src/assets/images/chatbot_white.png",
	"./check_blue.svg": "./src/assets/images/check_blue.svg",
	"./check_white.svg": "./src/assets/images/check_white.svg",
	"./clip.svg": "./src/assets/images/clip.svg",
	"./coachmark/coachmark_arrow_blue_01.svg": "./src/assets/images/coachmark/coachmark_arrow_blue_01.svg",
	"./coachmark/coachmark_arrow_blue_02.svg": "./src/assets/images/coachmark/coachmark_arrow_blue_02.svg",
	"./coachmark/coachmark_arrow_blue_03.svg": "./src/assets/images/coachmark/coachmark_arrow_blue_03.svg",
	"./coachmark/coachmark_arrow_blue_04.svg": "./src/assets/images/coachmark/coachmark_arrow_blue_04.svg",
	"./coachmark/coachmark_arrow_blue_05.svg": "./src/assets/images/coachmark/coachmark_arrow_blue_05.svg",
	"./coachmark/coachmark_arrow_blue_06.svg": "./src/assets/images/coachmark/coachmark_arrow_blue_06.svg",
	"./coachmark/coachmark_arrow_blue_07.svg": "./src/assets/images/coachmark/coachmark_arrow_blue_07.svg",
	"./coachmark/coachmark_arrow_blue_08.svg": "./src/assets/images/coachmark/coachmark_arrow_blue_08.svg",
	"./coachmark/coachmark_preview.png": "./src/assets/images/coachmark/coachmark_preview.png",
	"./controls_white.svg": "./src/assets/images/controls_white.svg",
	"./crown_black.svg": "./src/assets/images/crown_black.svg",
	"./crown_blue.svg": "./src/assets/images/crown_blue.svg",
	"./crown_white.svg": "./src/assets/images/crown_white.svg",
	"./crown_yellow.svg": "./src/assets/images/crown_yellow.svg",
	"./cs_person.png": "./src/assets/images/cs_person.png",
	"./doc_down.svg": "./src/assets/images/doc_down.svg",
	"./doc_down_drawing.svg": "./src/assets/images/doc_down_drawing.svg",
	"./download.svg": "./src/assets/images/download.svg",
	"./download_white.svg": "./src/assets/images/download_white.svg",
	"./drag.svg": "./src/assets/images/drag.svg",
	"./empty_note.svg": "./src/assets/images/empty_note.svg",
	"./exam_color.svg": "./src/assets/images/exam_color.svg",
	"./exam_obj_white.svg": "./src/assets/images/exam_obj_white.svg",
	"./exam_sub_white.svg": "./src/assets/images/exam_sub_white.svg",
	"./exam_white.svg": "./src/assets/images/exam_white.svg",
	"./excel.svg": "./src/assets/images/excel.svg",
	"./exclaim.svg": "./src/assets/images/exclaim.svg",
	"./exit_white.svg": "./src/assets/images/exit_white.svg",
	"./file.svg": "./src/assets/images/file.svg",
	"./flag.svg": "./src/assets/images/flag.svg",
	"./group.svg": "./src/assets/images/group.svg",
	"./heart_empty.svg": "./src/assets/images/heart_empty.svg",
	"./heart_red.svg": "./src/assets/images/heart_red.svg",
	"./info.svg": "./src/assets/images/info.svg",
	"./info_error.svg": "./src/assets/images/info_error.svg",
	"./info_success.svg": "./src/assets/images/info_success.svg",
	"./info_warning.svg": "./src/assets/images/info_warning.svg",
	"./info_white.svg": "./src/assets/images/info_white.svg",
	"./interpreter_white.svg": "./src/assets/images/interpreter_white.svg",
	"./language_white.svg": "./src/assets/images/language_white.svg",
	"./layout/auto.jpg": "./src/assets/images/layout/auto.jpg",
	"./layout/ml_01_00.jpg": "./src/assets/images/layout/ml_01_00.jpg",
	"./layout/ml_02_00.jpg": "./src/assets/images/layout/ml_02_00.jpg",
	"./layout/ml_02_03.jpg": "./src/assets/images/layout/ml_02_03.jpg",
	"./layout/ml_03_00.jpg": "./src/assets/images/layout/ml_03_00.jpg",
	"./layout/ml_04_00.jpg": "./src/assets/images/layout/ml_04_00.jpg",
	"./layout/ml_05_00.jpg": "./src/assets/images/layout/ml_05_00.jpg",
	"./layout/ml_05_01.jpg": "./src/assets/images/layout/ml_05_01.jpg",
	"./layout/ml_06_00.jpg": "./src/assets/images/layout/ml_06_00.jpg",
	"./layout/ml_07_00.jpg": "./src/assets/images/layout/ml_07_00.jpg",
	"./layout/ml_08_00.jpg": "./src/assets/images/layout/ml_08_00.jpg",
	"./layout/ml_09_00.jpg": "./src/assets/images/layout/ml_09_00.jpg",
	"./layout/ml_100_00.jpg": "./src/assets/images/layout/ml_100_00.jpg",
	"./layout/ml_10_00.jpg": "./src/assets/images/layout/ml_10_00.jpg",
	"./layout/ml_11_00.jpg": "./src/assets/images/layout/ml_11_00.jpg",
	"./layout/ml_11_01.jpg": "./src/assets/images/layout/ml_11_01.jpg",
	"./layout/ml_121_00.jpg": "./src/assets/images/layout/ml_121_00.jpg",
	"./layout/ml_12_00.jpg": "./src/assets/images/layout/ml_12_00.jpg",
	"./layout/ml_12_01.jpg": "./src/assets/images/layout/ml_12_01.jpg",
	"./layout/ml_13_00.jpg": "./src/assets/images/layout/ml_13_00.jpg",
	"./layout/ml_144_00.jpg": "./src/assets/images/layout/ml_144_00.jpg",
	"./layout/ml_16_00.jpg": "./src/assets/images/layout/ml_16_00.jpg",
	"./layout/ml_17_00.jpg": "./src/assets/images/layout/ml_17_00.jpg",
	"./layout/ml_19_00.jpg": "./src/assets/images/layout/ml_19_00.jpg",
	"./layout/ml_20_00.jpg": "./src/assets/images/layout/ml_20_00.jpg",
	"./layout/ml_21_00.jpg": "./src/assets/images/layout/ml_21_00.jpg",
	"./layout/ml_22_00.jpg": "./src/assets/images/layout/ml_22_00.jpg",
	"./layout/ml_22_01.jpg": "./src/assets/images/layout/ml_22_01.jpg",
	"./layout/ml_25_00.jpg": "./src/assets/images/layout/ml_25_00.jpg",
	"./layout/ml_30_00.jpg": "./src/assets/images/layout/ml_30_00.jpg",
	"./layout/ml_31_00.jpg": "./src/assets/images/layout/ml_31_00.jpg",
	"./layout/ml_31_01.jpg": "./src/assets/images/layout/ml_31_01.jpg",
	"./layout/ml_32_00.jpg": "./src/assets/images/layout/ml_32_00.jpg",
	"./layout/ml_32_01.jpg": "./src/assets/images/layout/ml_32_01.jpg",
	"./layout/ml_33_00.jpg": "./src/assets/images/layout/ml_33_00.jpg",
	"./layout/ml_36_00.jpg": "./src/assets/images/layout/ml_36_00.jpg",
	"./layout/ml_40_00.jpg": "./src/assets/images/layout/ml_40_00.jpg",
	"./layout/ml_41_00.jpg": "./src/assets/images/layout/ml_41_00.jpg",
	"./layout/ml_41_01.jpg": "./src/assets/images/layout/ml_41_01.jpg",
	"./layout/ml_42_00.jpg": "./src/assets/images/layout/ml_42_00.jpg",
	"./layout/ml_42_01.jpg": "./src/assets/images/layout/ml_42_01.jpg",
	"./layout/ml_43_00.jpg": "./src/assets/images/layout/ml_43_00.jpg",
	"./layout/ml_46_00.jpg": "./src/assets/images/layout/ml_46_00.jpg",
	"./layout/ml_49_00.jpg": "./src/assets/images/layout/ml_49_00.jpg",
	"./layout/ml_49_01.jpg": "./src/assets/images/layout/ml_49_01.jpg",
	"./layout/ml_56_00.jpg": "./src/assets/images/layout/ml_56_00.jpg",
	"./layout/ml_58_00.jpg": "./src/assets/images/layout/ml_58_00.jpg",
	"./layout/ml_61_00.jpg": "./src/assets/images/layout/ml_61_00.jpg",
	"./layout/ml_64_00.jpg": "./src/assets/images/layout/ml_64_00.jpg",
	"./layout/ml_81_00.jpg": "./src/assets/images/layout/ml_81_00.jpg",
	"./layout/old/auto.jpg": "./src/assets/images/layout/old/auto.jpg",
	"./layout/old/auto_over.jpg": "./src/assets/images/layout/old/auto_over.jpg",
	"./layout/old/ml_01_00.jpg": "./src/assets/images/layout/old/ml_01_00.jpg",
	"./layout/old/ml_01_00_over.jpg": "./src/assets/images/layout/old/ml_01_00_over.jpg",
	"./layout/old/ml_02_00.jpg": "./src/assets/images/layout/old/ml_02_00.jpg",
	"./layout/old/ml_02_00_over.jpg": "./src/assets/images/layout/old/ml_02_00_over.jpg",
	"./layout/old/ml_02_03.jpg": "./src/assets/images/layout/old/ml_02_03.jpg",
	"./layout/old/ml_02_03_over.jpg": "./src/assets/images/layout/old/ml_02_03_over.jpg",
	"./layout/old/ml_03_00.jpg": "./src/assets/images/layout/old/ml_03_00.jpg",
	"./layout/old/ml_03_00_over.jpg": "./src/assets/images/layout/old/ml_03_00_over.jpg",
	"./layout/old/ml_04_00.jpg": "./src/assets/images/layout/old/ml_04_00.jpg",
	"./layout/old/ml_04_00_over.jpg": "./src/assets/images/layout/old/ml_04_00_over.jpg",
	"./layout/old/ml_05_00.jpg": "./src/assets/images/layout/old/ml_05_00.jpg",
	"./layout/old/ml_05_00_over.jpg": "./src/assets/images/layout/old/ml_05_00_over.jpg",
	"./layout/old/ml_05_01.jpg": "./src/assets/images/layout/old/ml_05_01.jpg",
	"./layout/old/ml_05_01_over.jpg": "./src/assets/images/layout/old/ml_05_01_over.jpg",
	"./layout/old/ml_06_00.jpg": "./src/assets/images/layout/old/ml_06_00.jpg",
	"./layout/old/ml_06_00_over.jpg": "./src/assets/images/layout/old/ml_06_00_over.jpg",
	"./layout/old/ml_07_00.jpg": "./src/assets/images/layout/old/ml_07_00.jpg",
	"./layout/old/ml_07_00_over.jpg": "./src/assets/images/layout/old/ml_07_00_over.jpg",
	"./layout/old/ml_08_00.jpg": "./src/assets/images/layout/old/ml_08_00.jpg",
	"./layout/old/ml_08_00_over.jpg": "./src/assets/images/layout/old/ml_08_00_over.jpg",
	"./layout/old/ml_09_00.jpg": "./src/assets/images/layout/old/ml_09_00.jpg",
	"./layout/old/ml_09_00_over.jpg": "./src/assets/images/layout/old/ml_09_00_over.jpg",
	"./layout/old/ml_100_00.jpg": "./src/assets/images/layout/old/ml_100_00.jpg",
	"./layout/old/ml_100_00_over.jpg": "./src/assets/images/layout/old/ml_100_00_over.jpg",
	"./layout/old/ml_10_00.jpg": "./src/assets/images/layout/old/ml_10_00.jpg",
	"./layout/old/ml_10_00_over.jpg": "./src/assets/images/layout/old/ml_10_00_over.jpg",
	"./layout/old/ml_11_00.jpg": "./src/assets/images/layout/old/ml_11_00.jpg",
	"./layout/old/ml_11_00_over.jpg": "./src/assets/images/layout/old/ml_11_00_over.jpg",
	"./layout/old/ml_11_01.jpg": "./src/assets/images/layout/old/ml_11_01.jpg",
	"./layout/old/ml_11_01_over.jpg": "./src/assets/images/layout/old/ml_11_01_over.jpg",
	"./layout/old/ml_12_00.jpg": "./src/assets/images/layout/old/ml_12_00.jpg",
	"./layout/old/ml_12_00_over.jpg": "./src/assets/images/layout/old/ml_12_00_over.jpg",
	"./layout/old/ml_12_01.jpg": "./src/assets/images/layout/old/ml_12_01.jpg",
	"./layout/old/ml_12_01_over.jpg": "./src/assets/images/layout/old/ml_12_01_over.jpg",
	"./layout/old/ml_13_00.jpg": "./src/assets/images/layout/old/ml_13_00.jpg",
	"./layout/old/ml_13_00_over.jpg": "./src/assets/images/layout/old/ml_13_00_over.jpg",
	"./layout/old/ml_16_00.jpg": "./src/assets/images/layout/old/ml_16_00.jpg",
	"./layout/old/ml_16_00_over.jpg": "./src/assets/images/layout/old/ml_16_00_over.jpg",
	"./layout/old/ml_17_00.jpg": "./src/assets/images/layout/old/ml_17_00.jpg",
	"./layout/old/ml_17_00_over.jpg": "./src/assets/images/layout/old/ml_17_00_over.jpg",
	"./layout/old/ml_19_00.jpg": "./src/assets/images/layout/old/ml_19_00.jpg",
	"./layout/old/ml_19_00_over.jpg": "./src/assets/images/layout/old/ml_19_00_over.jpg",
	"./layout/old/ml_20_00.jpg": "./src/assets/images/layout/old/ml_20_00.jpg",
	"./layout/old/ml_20_00_over.jpg": "./src/assets/images/layout/old/ml_20_00_over.jpg",
	"./layout/old/ml_21_00.jpg": "./src/assets/images/layout/old/ml_21_00.jpg",
	"./layout/old/ml_21_00_over.jpg": "./src/assets/images/layout/old/ml_21_00_over.jpg",
	"./layout/old/ml_22_00.jpg": "./src/assets/images/layout/old/ml_22_00.jpg",
	"./layout/old/ml_22_00_over.jpg": "./src/assets/images/layout/old/ml_22_00_over.jpg",
	"./layout/old/ml_22_01.jpg": "./src/assets/images/layout/old/ml_22_01.jpg",
	"./layout/old/ml_22_01_over.jpg": "./src/assets/images/layout/old/ml_22_01_over.jpg",
	"./layout/old/ml_25_00.jpg": "./src/assets/images/layout/old/ml_25_00.jpg",
	"./layout/old/ml_25_00_over.jpg": "./src/assets/images/layout/old/ml_25_00_over.jpg",
	"./layout/old/ml_30_00.jpg": "./src/assets/images/layout/old/ml_30_00.jpg",
	"./layout/old/ml_30_00_over.jpg": "./src/assets/images/layout/old/ml_30_00_over.jpg",
	"./layout/old/ml_31_00.jpg": "./src/assets/images/layout/old/ml_31_00.jpg",
	"./layout/old/ml_31_00_over.jpg": "./src/assets/images/layout/old/ml_31_00_over.jpg",
	"./layout/old/ml_31_01.jpg": "./src/assets/images/layout/old/ml_31_01.jpg",
	"./layout/old/ml_31_01_over.jpg": "./src/assets/images/layout/old/ml_31_01_over.jpg",
	"./layout/old/ml_32_00.jpg": "./src/assets/images/layout/old/ml_32_00.jpg",
	"./layout/old/ml_32_00_over.jpg": "./src/assets/images/layout/old/ml_32_00_over.jpg",
	"./layout/old/ml_32_01.jpg": "./src/assets/images/layout/old/ml_32_01.jpg",
	"./layout/old/ml_32_01_over.jpg": "./src/assets/images/layout/old/ml_32_01_over.jpg",
	"./layout/old/ml_33_00.jpg": "./src/assets/images/layout/old/ml_33_00.jpg",
	"./layout/old/ml_33_00_over.jpg": "./src/assets/images/layout/old/ml_33_00_over.jpg",
	"./layout/old/ml_36_00.jpg": "./src/assets/images/layout/old/ml_36_00.jpg",
	"./layout/old/ml_36_00_over.jpg": "./src/assets/images/layout/old/ml_36_00_over.jpg",
	"./layout/old/ml_40_00.jpg": "./src/assets/images/layout/old/ml_40_00.jpg",
	"./layout/old/ml_40_00_over.jpg": "./src/assets/images/layout/old/ml_40_00_over.jpg",
	"./layout/old/ml_41_00.jpg": "./src/assets/images/layout/old/ml_41_00.jpg",
	"./layout/old/ml_41_00_over.jpg": "./src/assets/images/layout/old/ml_41_00_over.jpg",
	"./layout/old/ml_41_01.jpg": "./src/assets/images/layout/old/ml_41_01.jpg",
	"./layout/old/ml_41_01_over.jpg": "./src/assets/images/layout/old/ml_41_01_over.jpg",
	"./layout/old/ml_42_00.jpg": "./src/assets/images/layout/old/ml_42_00.jpg",
	"./layout/old/ml_42_00_over.jpg": "./src/assets/images/layout/old/ml_42_00_over.jpg",
	"./layout/old/ml_42_01.jpg": "./src/assets/images/layout/old/ml_42_01.jpg",
	"./layout/old/ml_42_01_over.jpg": "./src/assets/images/layout/old/ml_42_01_over.jpg",
	"./layout/old/ml_43_00.jpg": "./src/assets/images/layout/old/ml_43_00.jpg",
	"./layout/old/ml_43_00_over.jpg": "./src/assets/images/layout/old/ml_43_00_over.jpg",
	"./layout/old/ml_46_00.jpg": "./src/assets/images/layout/old/ml_46_00.jpg",
	"./layout/old/ml_46_00_over.jpg": "./src/assets/images/layout/old/ml_46_00_over.jpg",
	"./layout/old/ml_49_00.jpg": "./src/assets/images/layout/old/ml_49_00.jpg",
	"./layout/old/ml_49_00_over.jpg": "./src/assets/images/layout/old/ml_49_00_over.jpg",
	"./layout/old/ml_49_01.jpg": "./src/assets/images/layout/old/ml_49_01.jpg",
	"./layout/old/ml_49_01_over.jpg": "./src/assets/images/layout/old/ml_49_01_over.jpg",
	"./layout/old/ml_56_00.jpg": "./src/assets/images/layout/old/ml_56_00.jpg",
	"./layout/old/ml_56_00_over.jpg": "./src/assets/images/layout/old/ml_56_00_over.jpg",
	"./layout/old/ml_58_00.jpg": "./src/assets/images/layout/old/ml_58_00.jpg",
	"./layout/old/ml_58_00_over.jpg": "./src/assets/images/layout/old/ml_58_00_over.jpg",
	"./layout/old/ml_61_00.jpg": "./src/assets/images/layout/old/ml_61_00.jpg",
	"./layout/old/ml_61_00_over.jpg": "./src/assets/images/layout/old/ml_61_00_over.jpg",
	"./layout/old/ml_64_00.jpg": "./src/assets/images/layout/old/ml_64_00.jpg",
	"./layout/old/ml_64_00_over.jpg": "./src/assets/images/layout/old/ml_64_00_over.jpg",
	"./layout/old/ml_81_00.jpg": "./src/assets/images/layout/old/ml_81_00.jpg",
	"./layout/old/ml_81_00_over.jpg": "./src/assets/images/layout/old/ml_81_00_over.jpg",
	"./layout_white.svg": "./src/assets/images/layout_white.svg",
	"./link_blue.svg": "./src/assets/images/link_blue.svg",
	"./link_white.svg": "./src/assets/images/link_white.svg",
	"./loading_gooroomee.gif": "./src/assets/images/loading_gooroomee.gif",
	"./lock.svg": "./src/assets/images/lock.svg",
	"./lock_blue.svg": "./src/assets/images/lock_blue.svg",
	"./logo/deepHearing.png": "./src/assets/images/logo/deepHearing.png",
	"./logo_gooroomee_white.svg": "./src/assets/images/logo_gooroomee_white.svg",
	"./logo_grm_tx_white.svg": "./src/assets/images/logo_grm_tx_white.svg",
	"./media.svg": "./src/assets/images/media.svg",
	"./meeting-note/add_white.svg": "./src/assets/images/meeting-note/add_white.svg",
	"./meeting-note/ai_chat.svg": "./src/assets/images/meeting-note/ai_chat.svg",
	"./meeting-note/arrow_left_gray.svg": "./src/assets/images/meeting-note/arrow_left_gray.svg",
	"./meeting-note/download.svg": "./src/assets/images/meeting-note/download.svg",
	"./meeting-note/download_gray.svg": "./src/assets/images/meeting-note/download_gray.svg",
	"./meeting-note/download_white.svg": "./src/assets/images/meeting-note/download_white.svg",
	"./meeting-note/init.svg": "./src/assets/images/meeting-note/init.svg",
	"./meeting-note/ongoing.svg": "./src/assets/images/meeting-note/ongoing.svg",
	"./meeting-note/stopCircle.svg": "./src/assets/images/meeting-note/stopCircle.svg",
	"./meeting-note/trashcan.svg": "./src/assets/images/meeting-note/trashcan.svg",
	"./menu_ai_meeting_note_off.svg": "./src/assets/images/menu_ai_meeting_note_off.svg",
	"./menu_ai_meeting_note_on.svg": "./src/assets/images/menu_ai_meeting_note_on.svg",
	"./menu_attendance_white.svg": "./src/assets/images/menu_attendance_white.svg",
	"./menu_call_white.svg": "./src/assets/images/menu_call_white.svg",
	"./menu_docshare_white.svg": "./src/assets/images/menu_docshare_white.svg",
	"./menu_mediashare_white.svg": "./src/assets/images/menu_mediashare_white.svg",
	"./menu_meeting_note.png": "./src/assets/images/menu_meeting_note.png",
	"./menu_screenshare_white.svg": "./src/assets/images/menu_screenshare_white.svg",
	"./menu_translation_off.png": "./src/assets/images/menu_translation_off.png",
	"./menu_translation_on.png": "./src/assets/images/menu_translation_on.png",
	"./menu_waiting_white.svg": "./src/assets/images/menu_waiting_white.svg",
	"./menu_white.svg": "./src/assets/images/menu_white.svg",
	"./mic_off_gray.svg": "./src/assets/images/mic_off_gray.svg",
	"./mic_off_red.svg": "./src/assets/images/mic_off_red.svg",
	"./mic_off_white.svg": "./src/assets/images/mic_off_white.svg",
	"./mic_on.svg": "./src/assets/images/mic_on.svg",
	"./mic_on_blue.svg": "./src/assets/images/mic_on_blue.svg",
	"./mic_on_white.svg": "./src/assets/images/mic_on_white.svg",
	"./more.svg": "./src/assets/images/more.svg",
	"./more_gray.svg": "./src/assets/images/more_gray.svg",
	"./more_vertical.svg": "./src/assets/images/more_vertical.svg",
	"./more_vertical_gray.svg": "./src/assets/images/more_vertical_gray.svg",
	"./more_white.svg": "./src/assets/images/more_white.svg",
	"./new_window.svg": "./src/assets/images/new_window.svg",
	"./new_window_white.svg": "./src/assets/images/new_window_white.svg",
	"./no_signal_white.svg": "./src/assets/images/no_signal_white.svg",
	"./no_use_white.svg": "./src/assets/images/no_use_white.svg",
	"./notice.svg": "./src/assets/images/notice.svg",
	"./notice_white.svg": "./src/assets/images/notice_white.svg",
	"./openai.svg": "./src/assets/images/openai.svg",
	"./palette/all_eraser.svg": "./src/assets/images/palette/all_eraser.svg",
	"./palette/circle.svg": "./src/assets/images/palette/circle.svg",
	"./palette/diamond.svg": "./src/assets/images/palette/diamond.svg",
	"./palette/eraser_blue.svg": "./src/assets/images/palette/eraser_blue.svg",
	"./palette/eraser_gray.svg": "./src/assets/images/palette/eraser_gray.svg",
	"./palette/eraser_white.svg": "./src/assets/images/palette/eraser_white.svg",
	"./palette/figures_blue.svg": "./src/assets/images/palette/figures_blue.svg",
	"./palette/hand_blue.svg": "./src/assets/images/palette/hand_blue.svg",
	"./palette/highlighter_blue.svg": "./src/assets/images/palette/highlighter_blue.svg",
	"./palette/highlighter_gray.svg": "./src/assets/images/palette/highlighter_gray.svg",
	"./palette/highlighter_white.svg": "./src/assets/images/palette/highlighter_white.svg",
	"./palette/line.svg": "./src/assets/images/palette/line.svg",
	"./palette/minus.svg": "./src/assets/images/palette/minus.svg",
	"./palette/minus_white.svg": "./src/assets/images/palette/minus_white.svg",
	"./palette/pen_blue.svg": "./src/assets/images/palette/pen_blue.svg",
	"./palette/pen_gray.svg": "./src/assets/images/palette/pen_gray.svg",
	"./palette/pen_white.svg": "./src/assets/images/palette/pen_white.svg",
	"./palette/pentagon.svg": "./src/assets/images/palette/pentagon.svg",
	"./palette/play_white.svg": "./src/assets/images/palette/play_white.svg",
	"./palette/plus.svg": "./src/assets/images/palette/plus.svg",
	"./palette/plus_white.svg": "./src/assets/images/palette/plus_white.svg",
	"./palette/pointer_blue.svg": "./src/assets/images/palette/pointer_blue.svg",
	"./palette/pointer_gray.svg": "./src/assets/images/palette/pointer_gray.svg",
	"./palette/pointer_white.svg": "./src/assets/images/palette/pointer_white.svg",
	"./palette/rectangle.svg": "./src/assets/images/palette/rectangle.svg",
	"./palette/star.svg": "./src/assets/images/palette/star.svg",
	"./palette/text.svg": "./src/assets/images/palette/text.svg",
	"./palette/text_blue.svg": "./src/assets/images/palette/text_blue.svg",
	"./palette/thickness_blue.svg": "./src/assets/images/palette/thickness_blue.svg",
	"./palette/triangle.svg": "./src/assets/images/palette/triangle.svg",
	"./palette/twolines.svg": "./src/assets/images/palette/twolines.svg",
	"./palette/zoom_blue.svg": "./src/assets/images/palette/zoom_blue.svg",
	"./palette/zoom_fit.svg": "./src/assets/images/palette/zoom_fit.svg",
	"./palette/zoom_fit_white.svg": "./src/assets/images/palette/zoom_fit_white.svg",
	"./palette/zoom_ori.svg": "./src/assets/images/palette/zoom_ori.svg",
	"./palette/zoom_ori_white.svg": "./src/assets/images/palette/zoom_ori_white.svg",
	"./pause.svg": "./src/assets/images/pause.svg",
	"./pause_white.svg": "./src/assets/images/pause_white.svg",
	"./pen.svg": "./src/assets/images/pen.svg",
	"./pen_gray.svg": "./src/assets/images/pen_gray.svg",
	"./play_white.svg": "./src/assets/images/play_white.svg",
	"./plus.svg": "./src/assets/images/plus.svg",
	"./plus_blue.svg": "./src/assets/images/plus_blue.svg",
	"./plus_white.svg": "./src/assets/images/plus_white.svg",
	"./profile.svg": "./src/assets/images/profile.svg",
	"./qna_white.svg": "./src/assets/images/qna_white.svg",
	"./question.svg": "./src/assets/images/question.svg",
	"./quiz.svg": "./src/assets/images/quiz.svg",
	"./record.svg": "./src/assets/images/record.svg",
	"./repeat.svg": "./src/assets/images/repeat.svg",
	"./repeat_one.svg": "./src/assets/images/repeat_one.svg",
	"./repeat_one_white.svg": "./src/assets/images/repeat_one_white.svg",
	"./repeat_white.svg": "./src/assets/images/repeat_white.svg",
	"./replyLine_gray.svg": "./src/assets/images/replyLine_gray.svg",
	"./reset.svg": "./src/assets/images/reset.svg",
	"./rotate_white.svg": "./src/assets/images/rotate_white.svg",
	"./screen.svg": "./src/assets/images/screen.svg",
	"./screen_decrease.svg": "./src/assets/images/screen_decrease.svg",
	"./screen_decrease_white.svg": "./src/assets/images/screen_decrease_white.svg",
	"./screen_gray.svg": "./src/assets/images/screen_gray.svg",
	"./screen_increase.svg": "./src/assets/images/screen_increase.svg",
	"./screen_increase_white.svg": "./src/assets/images/screen_increase_white.svg",
	"./screen_on.svg": "./src/assets/images/screen_on.svg",
	"./screen_share.svg": "./src/assets/images/screen_share.svg",
	"./search.svg": "./src/assets/images/search.svg",
	"./search_blue.svg": "./src/assets/images/search_blue.svg",
	"./search_gray.svg": "./src/assets/images/search_gray.svg",
	"./set_chat.svg": "./src/assets/images/set_chat.svg",
	"./set_display.svg": "./src/assets/images/set_display.svg",
	"./set_doc.svg": "./src/assets/images/set_doc.svg",
	"./set_general.svg": "./src/assets/images/set_general.svg",
	"./set_group.svg": "./src/assets/images/set_group.svg",
	"./set_join.svg": "./src/assets/images/set_join.svg",
	"./set_more.svg": "./src/assets/images/set_more.svg",
	"./set_quality.svg": "./src/assets/images/set_quality.svg",
	"./set_share.svg": "./src/assets/images/set_share.svg",
	"./setting_line_gray.svg": "./src/assets/images/setting_line_gray.svg",
	"./setting_white.svg": "./src/assets/images/setting_white.svg",
	"./smile_white.svg": "./src/assets/images/smile_white.svg",
	"./social/band.png": "./src/assets/images/social/band.png",
	"./social/facebook.png": "./src/assets/images/social/facebook.png",
	"./social/kakao.png": "./src/assets/images/social/kakao.png",
	"./social/mail.svg": "./src/assets/images/social/mail.svg",
	"./speaker_off_gray.svg": "./src/assets/images/speaker_off_gray.svg",
	"./speaker_off_red.svg": "./src/assets/images/speaker_off_red.svg",
	"./speaker_off_white.svg": "./src/assets/images/speaker_off_white.svg",
	"./speaker_on.svg": "./src/assets/images/speaker_on.svg",
	"./speaker_on_white.svg": "./src/assets/images/speaker_on_white.svg",
	"./sticker/sticker_1.svg": "./src/assets/images/sticker/sticker_1.svg",
	"./sticker/sticker_10.svg": "./src/assets/images/sticker/sticker_10.svg",
	"./sticker/sticker_10_icon.svg": "./src/assets/images/sticker/sticker_10_icon.svg",
	"./sticker/sticker_11.svg": "./src/assets/images/sticker/sticker_11.svg",
	"./sticker/sticker_12.svg": "./src/assets/images/sticker/sticker_12.svg",
	"./sticker/sticker_13.svg": "./src/assets/images/sticker/sticker_13.svg",
	"./sticker/sticker_14.svg": "./src/assets/images/sticker/sticker_14.svg",
	"./sticker/sticker_15.svg": "./src/assets/images/sticker/sticker_15.svg",
	"./sticker/sticker_16.svg": "./src/assets/images/sticker/sticker_16.svg",
	"./sticker/sticker_17.svg": "./src/assets/images/sticker/sticker_17.svg",
	"./sticker/sticker_18.svg": "./src/assets/images/sticker/sticker_18.svg",
	"./sticker/sticker_19.svg": "./src/assets/images/sticker/sticker_19.svg",
	"./sticker/sticker_2.svg": "./src/assets/images/sticker/sticker_2.svg",
	"./sticker/sticker_20.svg": "./src/assets/images/sticker/sticker_20.svg",
	"./sticker/sticker_21.svg": "./src/assets/images/sticker/sticker_21.svg",
	"./sticker/sticker_21_icon.svg": "./src/assets/images/sticker/sticker_21_icon.svg",
	"./sticker/sticker_22.svg": "./src/assets/images/sticker/sticker_22.svg",
	"./sticker/sticker_22_icon.svg": "./src/assets/images/sticker/sticker_22_icon.svg",
	"./sticker/sticker_23.svg": "./src/assets/images/sticker/sticker_23.svg",
	"./sticker/sticker_23_icon.svg": "./src/assets/images/sticker/sticker_23_icon.svg",
	"./sticker/sticker_24.svg": "./src/assets/images/sticker/sticker_24.svg",
	"./sticker/sticker_24_icon.svg": "./src/assets/images/sticker/sticker_24_icon.svg",
	"./sticker/sticker_3.svg": "./src/assets/images/sticker/sticker_3.svg",
	"./sticker/sticker_4.svg": "./src/assets/images/sticker/sticker_4.svg",
	"./sticker/sticker_5.svg": "./src/assets/images/sticker/sticker_5.svg",
	"./sticker/sticker_6.svg": "./src/assets/images/sticker/sticker_6.svg",
	"./sticker/sticker_7.svg": "./src/assets/images/sticker/sticker_7.svg",
	"./sticker/sticker_7_icon.svg": "./src/assets/images/sticker/sticker_7_icon.svg",
	"./sticker/sticker_8.svg": "./src/assets/images/sticker/sticker_8.svg",
	"./sticker/sticker_8_icon.svg": "./src/assets/images/sticker/sticker_8_icon.svg",
	"./sticker/sticker_9.svg": "./src/assets/images/sticker/sticker_9.svg",
	"./sticker/sticker_9_icon.svg": "./src/assets/images/sticker/sticker_9_icon.svg",
	"./survey_color.svg": "./src/assets/images/survey_color.svg",
	"./timer.svg": "./src/assets/images/timer.svg",
	"./translation_AR.png": "./src/assets/images/translation_AR.png",
	"./translation_DE.png": "./src/assets/images/translation_DE.png",
	"./translation_EN.png": "./src/assets/images/translation_EN.png",
	"./translation_ES.png": "./src/assets/images/translation_ES.png",
	"./translation_JA.png": "./src/assets/images/translation_JA.png",
	"./translation_KO.png": "./src/assets/images/translation_KO.png",
	"./translation_RU.png": "./src/assets/images/translation_RU.png",
	"./translation_VI.png": "./src/assets/images/translation_VI.png",
	"./translation_ZH-CN.png": "./src/assets/images/translation_ZH-CN.png",
	"./translation_ZH-TW.png": "./src/assets/images/translation_ZH-TW.png",
	"./trash.svg": "./src/assets/images/trash.svg",
	"./trash_red.svg": "./src/assets/images/trash_red.svg",
	"./trash_white.svg": "./src/assets/images/trash_white.svg",
	"./upload_blue.svg": "./src/assets/images/upload_blue.svg",
	"./userCount_gray.svg": "./src/assets/images/userCount_gray.svg",
	"./userCount_white.svg": "./src/assets/images/userCount_white.svg",
	"./userInvite_white.svg": "./src/assets/images/userInvite_white.svg",
	"./user_device_mobile.svg": "./src/assets/images/user_device_mobile.svg",
	"./user_device_pc.svg": "./src/assets/images/user_device_pc.svg",
	"./user_device_pc_in.svg": "./src/assets/images/user_device_pc_in.svg",
	"./user_device_tablet.svg": "./src/assets/images/user_device_tablet.svg",
	"./user_profile.svg": "./src/assets/images/user_profile.svg",
	"./virtual-background/virtual_background_blur.jpg": "./src/assets/images/virtual-background/virtual_background_blur.jpg",
	"./virtual-background/virtual_background_blur.png": "./src/assets/images/virtual-background/virtual_background_blur.png",
	"./virtual-background/virtual_background_inside_01.jpg": "./src/assets/images/virtual-background/virtual_background_inside_01.jpg",
	"./virtual-background/virtual_background_inside_01.png": "./src/assets/images/virtual-background/virtual_background_inside_01.png",
	"./virtual-background/virtual_background_inside_02.jpg": "./src/assets/images/virtual-background/virtual_background_inside_02.jpg",
	"./virtual-background/virtual_background_inside_02.png": "./src/assets/images/virtual-background/virtual_background_inside_02.png",
	"./virtual-background/virtual_background_inside_03.jpg": "./src/assets/images/virtual-background/virtual_background_inside_03.jpg",
	"./virtual-background/virtual_background_inside_03.png": "./src/assets/images/virtual-background/virtual_background_inside_03.png",
	"./virtual-background/virtual_background_inside_04.jpg": "./src/assets/images/virtual-background/virtual_background_inside_04.jpg",
	"./virtual-background/virtual_background_inside_04.png": "./src/assets/images/virtual-background/virtual_background_inside_04.png",
	"./virtual-background/virtual_background_outside_01.jpg": "./src/assets/images/virtual-background/virtual_background_outside_01.jpg",
	"./virtual-background/virtual_background_outside_01.png": "./src/assets/images/virtual-background/virtual_background_outside_01.png",
	"./virtual-background/virtual_background_outside_02.jpg": "./src/assets/images/virtual-background/virtual_background_outside_02.jpg",
	"./virtual-background/virtual_background_outside_02.png": "./src/assets/images/virtual-background/virtual_background_outside_02.png",
	"./voiceRequest_white.svg": "./src/assets/images/voiceRequest_white.svg",
	"./whisper_white.svg": "./src/assets/images/whisper_white.svg",
	"./write.svg": "./src/assets/images/write.svg",
	"./x.svg": "./src/assets/images/x.svg",
	"./x_gray.svg": "./src/assets/images/x_gray.svg",
	"./x_white.svg": "./src/assets/images/x_white.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*$";